import {Pipe, PipeTransform} from '@angular/core';
import {StepsWizardEntry} from '@component/steps-wizard/steps-wizard.adapter';

@Pipe({
    name: 'filterUnanswered',
    pure: false,
})
export class FilterUnansweredPipe implements PipeTransform {
    transform(items: StepsWizardEntry[]): any[] {
        if (!items || !Array.isArray(items)) {
            return [];
        }

        return items.filter(item =>
            item.hasAnswer === false &&
            !(item.value && item.value.includes('icon')),
        );
    }
}
